/** @jsx jsx */
import { css } from '@emotion/react'

export const btnKnowUniforms = css`
  margin-bottom: 100px;
  padding: 16px 32.5px;
  height: 52px;
  background: #4BE66A;
  font-weight: 700;
  font-size: 16px;
  line-height: 120%;
  text-align: center;
  color: #312E2D;
  font-variation-settings: "wght" 700;
  :hover {
    background: #00854E;
    color: #ffffff;
    text-decoration: none;
  }
  :active {
    background: #F7FF53;
    color: #312E2D;
    text-decoration: none;
  }
  @media (max-width: 992px){
    font-size: 10px;
    }
    @media (max-width: 700px){
    font-size: 16px;
    }
`


export const carouselStoreSwipe = css` 
  background: #FFE8DD;
  overflow: hidden;
  img {
    margin-bottom: 40px;
  }
  h2 {
    color: #F26F33;
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
    height: 48px;
    margin-bottom: 8px;
    @media only screen and (max-width: 600px) {
      height: auto;
    }
  }

  h3 {
    color: #686868;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%; /* 16.8px */
    letter-spacing: 1.68px;
    text-transform: uppercase;
    margin-bottom: 24px;
  }
  
  p {
    color: #686868;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    margin-bottom: 0px;
    height: 34px;
  }

  a{
    padding-left: 32px;
    @media (max-width: 1200px){
      
    }
  }

  .slideCarrousel{
    padding-bottom: 50px;
  }

  .containerTexts{
    padding-left: 24px;
    @media (max-width: 700px){
      padding-left: 24px;
    }
  }

  .containerImg{
    max-width: 390px;
    @media (max-width: 1200px){
      max-width: 300px;
    }
    @media (max-width: 992px){
      max-width: 250px;
    }
    @media (max-width: 600px){
      max-width: 450px;
    }
  }

  .itemImg{
    width: 100%;
    height: auto;
  }

  .swiper {
    grid-area: slider;
    width: 170%;
    height: auto;
    padding-right: 36px;
    
  }
   
  .swiper-slide {
    width: 335px;
    @media (max-width: 1200px){
      width: 300px;
    }
    @media (max-width: 992px){
      max-width: 250px;
      padding-right: 20px;
    }
    @media (max-width: 600px){
      max-width: 450px;
      padding-left: 12px;
    }
  }

  .swiper-slide-prev{
    width: 335px;
    @media (max-width: 1200px){
      width: 300px;
    }
    @media (max-width: 992px){
      max-width: 250px;
    }
    @media (max-width: 600px){
      max-width: 450px;
    }
  }

  .swiper-slide-next{
    width: 335px;
    @media (max-width: 1200px){
      width: 300px; 
    }
    @media (max-width: 992px){
      max-width: 250px;
    }
    @media (max-width: 600px){
      max-width: 450px;
    }
  }
 
  .swiper-slide-active{
    width: 335px;
    @media (max-width: 1200px){
      width: 300px;
    }
    @media (max-width: 992px){
      max-width: 250px;
    }
    @media (max-width: 600px){
      max-width: 450px;
    }
  }

.swiper-horizontal>.swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal, .swiper-pagination-custom, .swiper-pagination-fraction {
    display: none;
}

  .box-calendario {
    border-radius: 56px;
    background: #FFF;
    padding-top: 48px;
    padding-left: 32px;
    padding-right: 32px;
    padding-bottom: 108px;
  }
`

export const carouselEstruturaSwipe = css` 
  background: #FFE8DD;
  overflow: hidden;
  img {
    margin-bottom: 40px;
  }
  .img-estrutura {
    border-radius: 40px;
  }
  h2 {
    color: #F26F33;
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
    height: 48px;
    margin-bottom: 8px;
  }

  h3 {
    color: #686868;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%; /* 16.8px */
    letter-spacing: 1.68px;
    text-transform: uppercase;
    margin-bottom: 24px;
  }
  
  p {
    color: #686868;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    margin-bottom: 0px;
    height: 34px;
  }

  a{
    padding-left: 32px;
    @media (max-width: 1200px){
      
    }
  }

  .slideCarrousel{
    padding-bottom: 50px;
  }

  .containerTexts{
    padding-left: 24px;
    @media (max-width: 700px){
      padding-left: 24px;
    }
  }

  .containerImg{
    max-width: 390px;
    @media (max-width: 1200px){
      max-width: 300px;
    }
    @media (max-width: 992px){
      max-width: 250px;
    }
    @media (max-width: 600px){
      max-width: 450px;
    }
  }

  .itemImg{
    width: 100%;
    height: auto;
  }

  .swiper {
    grid-area: slider;
    width: 170%;
    height: auto;
    padding-right: 36px;
    
  }
   
  .swiper-slide {
    width: 280px;
    @media (max-width: 1200px){
      width: 300px;
    }
    @media (max-width: 992px){
      max-width: 250px;
      padding-right: 20px;
    }
    @media (max-width: 600px){
      max-width: 450px;
      padding-left: 12px;
    }
  }

  .swiper-slide-prev{
    width: 280px;
    @media (max-width: 1200px){
      width: 300px;
    }
    @media (max-width: 992px){
      max-width: 250px;
    }
    @media (max-width: 600px){
      max-width: 450px;
    }
  }

  .swiper-slide-next{
    width: 280px;
    @media (max-width: 1200px){
      width: 300px; 
    }
    @media (max-width: 992px){
      max-width: 250px;
    }
    @media (max-width: 600px){
      max-width: 450px;
    }
  }
 
  .swiper-slide-active{
    width: 280px;
    @media (max-width: 1200px){
      width: 300px;
    }
    @media (max-width: 992px){
      max-width: 250px;
    }
    @media (max-width: 600px){
      max-width: 450px;
    }
  }

.swiper-horizontal>.swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal, .swiper-pagination-custom, .swiper-pagination-fraction {
    display: none;
}

  .box-calendario {
    border-radius: 56px;
    background: #FFF;
    padding-top: 48px;
    padding-left: 32px;
    padding-right: 32px;
    padding-bottom: 108px;
  }
`

export const carouselLojaHomeSwipe = css` 
  background: #FFE8DD;
  overflow: hidden;
  padding-bottom: 120px;
  img {
    margin-bottom: 40px;
  }
  .img-estrutura {
    border-radius: 40px;
  }
  h2 {
    color: #F26F33;
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
    height: 48px;
    margin-bottom: 8px;
  }

  h3 {
    color: #686868;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%; /* 16.8px */
    letter-spacing: 1.68px;
    text-transform: uppercase;
    margin-bottom: 24px;
  }
  
  p {
    color: #686868;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    margin-bottom: 0px;
    height: 34px;
  }

  a{
    padding-left: 32px;
    @media (max-width: 1200px){
      
    }
  }

  .slideCarrousel{
    padding-bottom: 50px;
  }

  .containerTexts{
    padding-left: 24px;
    @media (max-width: 700px){
      padding-left: 24px;
    }
  }

  .containerImg{
    max-width: 390px;
    @media (max-width: 1200px){
      max-width: 300px;
    }
    @media (max-width: 992px){
      max-width: 250px;
    }
    @media (max-width: 600px){
      max-width: 450px;
    }
  }

  .itemImg{
    width: 100%;
    height: auto;
  }

  .swiper {
    grid-area: slider;
    width: 170%;
    height: auto;
    padding-right: 36px;
    
  }
   
  .swiper-slide {
    width: 280px;
    @media (max-width: 1200px){
      width: 300px;
    }
    @media (max-width: 992px){
      max-width: 250px;
      padding-right: 20px;
    }
    @media (max-width: 600px){
      max-width: 450px;
      padding-left: 12px;
    }
  }

  .swiper-slide-prev{
    width: 280px;
    @media (max-width: 1200px){
      width: 300px;
    }
    @media (max-width: 992px){
      max-width: 250px;
    }
    @media (max-width: 600px){
      max-width: 450px;
    }
  }

  .swiper-slide-next{
    width: 280px;
    @media (max-width: 1200px){
      width: 300px; 
    }
    @media (max-width: 992px){
      max-width: 250px;
    }
    @media (max-width: 600px){
      max-width: 450px;
    }
  }
 
  .swiper-slide-active{
    width: 280px;
    @media (max-width: 1200px){
      width: 300px;
    }
    @media (max-width: 992px){
      max-width: 250px;
    }
    @media (max-width: 600px){
      max-width: 450px;
    }
  }

.swiper-horizontal>.swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal, .swiper-pagination-custom, .swiper-pagination-fraction {
    display: none;
}

  .box-calendario {
    border-radius: 56px;
    background: #FFF;
    padding-top: 48px;
    padding-left: 32px;
    padding-right: 32px;
    padding-bottom: 108px;
  }

  .button-link {
    border-radius: 16px;
    background: #F26F33;
    border: none;
    color: #FFEBD2;
    text-align: center;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    padding: 15px 56px;
    :hover {
      background-color: #CF4201;
      text-decoration: none;
    }
    :active {
      background-color: #8F2E01;
    }
  }
  
`

export const carouselEducacaoInfantilSwipe = css` 
  background: #FFFFFF;
  overflow: hidden;
  img {
    margin-bottom: 40px;
  }
  .img-estrutura {
    border-radius: 40px;
  }
  h2 {
    color: #F26F33;
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
    height: 48px;
    margin-bottom: 8px;
  }

  h3 {
    color: #686868;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%; /* 16.8px */
    letter-spacing: 1.68px;
    text-transform: uppercase;
    margin-bottom: 24px;
  }
  
  p {
    color: #686868;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    margin-bottom: 0px;
    height: 34px;
  }

  a{
    padding-left: 32px;
    @media (max-width: 1200px){
      
    }
  }

  .slideCarrousel{
    padding-bottom: 50px;
  }

  .containerTexts{
    padding-left: 24px;
    @media (max-width: 700px){
      padding-left: 24px;
    }
  }

  .containerImg{
    max-width: 390px;
    @media (max-width: 1200px){
      max-width: 300px;
    }
    @media (max-width: 992px){
      max-width: 250px;
    }
    @media (max-width: 600px){
      max-width: 450px;
    }
  }

  .itemImg{
    width: 100%;
    height: auto;
  }

  .swiper {
    grid-area: slider;
    width: 170%;
    height: auto;
    padding-right: 36px;
    
  }
   
  .swiper-slide {
    width: 280px;
    @media (max-width: 1200px){
      width: 300px;
    }
    @media (max-width: 992px){
      max-width: 250px;
      padding-right: 20px;
    }
    @media (max-width: 600px){
      max-width: 450px;
      padding-left: 12px;
    }
  }

  .swiper-slide-prev{
    width: 280px;
    @media (max-width: 1200px){
      width: 300px;
    }
    @media (max-width: 992px){
      max-width: 250px;
    }
    @media (max-width: 600px){
      max-width: 450px;
    }
  }

  .swiper-slide-next{
    width: 280px;
    @media (max-width: 1200px){
      width: 300px; 
    }
    @media (max-width: 992px){
      max-width: 250px;
    }
    @media (max-width: 600px){
      max-width: 450px;
    }
  }
 
  .swiper-slide-active{
    width: 280px;
    @media (max-width: 1200px){
      width: 300px;
    }
    @media (max-width: 992px){
      max-width: 250px;
    }
    @media (max-width: 600px){
      max-width: 450px;
    }
  }

.swiper-horizontal>.swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal, .swiper-pagination-custom, .swiper-pagination-fraction {
    display: none;
}

  .box-calendario {
    border-radius: 56px;
    background: #FFF;
    padding-top: 48px;
    padding-left: 32px;
    padding-right: 32px;
    padding-bottom: 108px;
  }
`